import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import Field from '#client/components/Field';

import usePostalCodeField from './usePostalCodeField';

function PostalCodeField({ helperText, namePrefix, validation, ...delegated }) {
  const { error, field } = usePostalCodeField({ namePrefix, validation });

  return (
    <Field
      {...field}
      error={error}
      helperText={helperText || error?.message}
      inputProps={{
        autoComplete: 'postal-code',
        'data-testid': 'postal-code',
        inputMode: 'numeric'
      }}
      label={<FormattedMessage id="shopping.component.addressFieldset.postalCodeField.label" />}
      {...delegated}
    />
  );
}

PostalCodeField.propTypes = {
  helperText: PropTypes.string,
  namePrefix: PropTypes.string,
  validation: PropTypes.object
};

export default PostalCodeField;
